import setReduxAction from '../set'
import { deleteInstanceReduxUtil } from '../../utils/delete-instance'

/**
 * Action called once a instance is deleted remotely. It:
 * - Deletes the instance from the state
 * @param {Object} params
 *        {Object} params.payload
 *        {string} params.payload.model
 */
function afterDeleteReduxAction (params) {
  return (dispatch, getState) => {
    const { payload } = params
    const { instance } = payload
    const state = deleteInstanceReduxUtil(getState(), instance)
    dispatch(setReduxAction({
      type: params.type + '_AFTER_DELETE',
      payload: {
        value: state
      }
    }))
  }
}

export default afterDeleteReduxAction
